import { makeStyles, styled } from "@material-ui/styles";
import { CollapsableSection, Column, FormSelect, Option } from "lqx-react";
import React from "react";
import {
    FormLabel,
    Input
} from "lqx-react/lib";
import { ErrorHighligter, DigiDateInput, asTimelessLinkedDate } from "../shared";
import { AssetColumn, numberInputStyles } from "../components/number-input";
import { DigiSelectAsync } from "../components/select-async";
import NumberFormat from "react-number-format";
import { getCompaniesAsCommonParticipants } from "../api/company";
import { Payment } from "../api/payment";
import { PaymentMethods, PaymentTypes } from "../api/reference-data";
import { DigiCurrencySelect, DigiSelect } from "../components/select";
import { globalStore } from 'api/store';

export const EditPaymentTab = ({ payment, errors }: { payment: Payment, errors }) => {
    const sectionStyles = SectionStyles();
    const classesNum = numberInputStyles();
    const classes = useStyles();

    return (<>
        <CollapsableSection title="General" titleClassName={sectionStyles.sectionTitle} noBorder noShadow>
            <Column>
                <FlexStyled>
                    <StyledFormLabel>Payor</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.DebtorBankAccount']}>
                        <DigiSelectAsync
                            data-qa-id={"payor"}
                            getItems={getCompaniesAsCommonParticipants}
                            $value={payment.debtorBankAccount.$.payor}
                            styles={{ minWidth: '362px' }}
                        />
                    </ErrorHighligterStyled>
                </FlexStyled>
                <CollapsableSection title="Bank Account Information  " noMargins>
                    <Column>
                        <FlexStyled>
                            <StyledFormLabel>Name</StyledFormLabel>
                            <ErrorHighligterStyled error={errors['dataset.DebtorBankAccountName']}>
                                <InputWrraper>
                                    <Input $value={payment.debtorBankAccount.$.name} />
                                </InputWrraper>
                            </ErrorHighligterStyled>
                        </FlexStyled>
                        <FlexStyled>
                            <StyledFormLabel>Alias</StyledFormLabel>
                            <ErrorHighligterStyled error={errors['dataset.DebtorBankAccountAlias']}>
                                <InputWrraper>
                                    <Input $value={payment.debtorBankAccount.$.alias} />
                                </InputWrraper>
                            </ErrorHighligterStyled>
                        </FlexStyled>
                        <FlexStyled>
                            <StyledFormLabel>Account Number</StyledFormLabel>
                            <ErrorHighligterStyled error={errors['dataset.DebtorBankAccountAccountNumber']}>
                                <InputWrraper>
                                    <Input $value={payment.debtorBankAccount.$.number} />
                                </InputWrraper>
                            </ErrorHighligterStyled>
                        </FlexStyled>
                        <FlexStyled>
                            <StyledFormLabel>Address</StyledFormLabel>
                            <ErrorHighligterStyled error={errors['dataset.DebtorBankAccountAccountAddress']}>
                                <InputWrraper>
                                    <Input $value={payment.debtorBankAccount.$.address} />
                                </InputWrraper>
                            </ErrorHighligterStyled>
                        </FlexStyled>
                    </Column>
                </CollapsableSection>
                <FlexStyled>
                    <StyledFormLabel>Payee</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.CreditorBankAccount']}>
                        <DigiSelectAsync
                            data-qa-id={"payee"}
                            getItems={getCompaniesAsCommonParticipants}
                            $value={payment.creditorBankAccount.$.payee}
                            styles={{ minWidth: '362px' }}
                        />
                    </ErrorHighligterStyled>
                </FlexStyled>
                <CollapsableSection title="Bank Account Information  " noMargins>
                    <FlexStyled>
                        <StyledFormLabel>Name</StyledFormLabel>
                        <ErrorHighligterStyled error={errors['dataset.CreditorBankAccountName']}>
                            <InputWrraper>
                                <Input $value={payment.creditorBankAccount.$.name} />
                            </InputWrraper>
                        </ErrorHighligterStyled>
                    </FlexStyled>
                    <FlexStyled>
                        <StyledFormLabel>Alias</StyledFormLabel>
                        <ErrorHighligterStyled error={errors['dataset.CreditorBankAccountAlias']}>
                            <InputWrraper>
                                <Input $value={payment.creditorBankAccount.$.alias} />
                            </InputWrraper>
                        </ErrorHighligterStyled>
                    </FlexStyled>
                    <FlexStyled>
                        <StyledFormLabel>Account Number</StyledFormLabel>
                        <ErrorHighligterStyled error={errors['dataset.CreditorBankAccountAccountNumber']}>
                            <InputWrraper>
                                <Input $value={payment.creditorBankAccount.$.number} />
                            </InputWrraper>
                        </ErrorHighligterStyled>
                    </FlexStyled>
                    <FlexStyled>
                        <StyledFormLabel>Address</StyledFormLabel>
                        <ErrorHighligterStyled error={errors['dataset.CreditorBankAccountAccountAddress']}>
                            <InputWrraper>
                                <Input $value={payment.creditorBankAccount.$.address} />
                            </InputWrraper>
                        </ErrorHighligterStyled>
                    </FlexStyled>
                </CollapsableSection>
                <FlexStyled>
                    <StyledFormLabel>Payment Type</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.PaymentType']}>
                        <InputWrraper>
                            <DigiSelect data-qa-id="payment type" id="id" label="name" $value={payment.$.paymentType} options={PaymentTypes} styles={digiSelectStyles} />
                        </InputWrraper>
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled style={{ marginTop: '3px' }}>
                    <StyledFormLabel>Reference Number</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.ReferenceNumber']}>
                        <InputWrraper>
                            <Input data-qa-id="reference number" $value={payment.$.referenceNumber} />
                        </InputWrraper>
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Payment Amount</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.PaymentAmount']}>
                        <InputWrraper>
                            <NumberFormat value={payment.paymentAmount} className={classes.numericInput} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} onValueChange={(values) => { const { floatValue } = values; payment.$.paymentAmount.set(floatValue) }} />
                        </InputWrraper>
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Currency</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.Currency']}>
                        <InputWrraper>
                            <DigiCurrencySelect
                                isMulti={false}
                                options={globalStore.currenciesLookup.items.models}
                                $value={payment.$.currency}
                            />
                        </InputWrraper>
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Value Date *</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.AssetPaymentDate']}>
                        <DigiDateWrapper>
                            <DigiDateInput date $value={asTimelessLinkedDate(payment.$.assetPaymentDate)} />
                        </DigiDateWrapper>
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Original Asset Obligor</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.OriginalAssetObligor']}>
                        <DigiSelectAsync
                            data-qa-id={"originalAssetObligor"}
                            getItems={getCompaniesAsCommonParticipants}
                            $value={payment.$.originalAssetObligor}
                            styles={{ minWidth: '350px' }}
                        />
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Payment Details</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.PaymentDetails']}>
                        <InputWrraper>
                            <Input data-qa-id="payment details" $value={payment.$.paymentDetails} />
                        </InputWrraper>
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Lock Box Number</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.LockBoxNumber']}>
                        <InputWrraper>
                            <Input data-qa-id="lock box number" $value={payment.$.lockBoxNumber} />
                        </InputWrraper>
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Payment Method</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.PaymentMethod']}>
                        <InputWrraper>
                            <DigiSelect data-qa-id="payment method" id="id" label="name" $value={payment.$.paymentMethod} options={PaymentMethods} aria-label="Payment Method" />
                        </InputWrraper>
                    </ErrorHighligterStyled>
                </FlexStyled>
                <FlexStyled>
                    <StyledFormLabel>Bank Entry Date</StyledFormLabel>
                    <ErrorHighligterStyled error={errors['dataset.BankEntryDate']}>
                        <DigiDateWrapper>
                            <DigiDateInput date $value={asTimelessLinkedDate(payment.$.bankEntryDate)} />
                        </DigiDateWrapper>
                    </ErrorHighligterStyled>
                </FlexStyled>
            </Column>
        </CollapsableSection>
    </>)
}

const digiSelectStyles = {
    control: provided => ({
        ...provided,
        height: 36,
    }),
    valueContainer: (provided) => ({
        ...provided,
        fontSize: '14px',
        fontWeight: 500,
        padding: '0px 8px',
    })
}

const useStyles = makeStyles({
    numericInput: {
        color: '#000',
        width: '100%',
        border: '1px solid #E3E9ED',
        padding: '4px 3px 3px 3px',
        fontSize: '14px',
        boxSizing: 'border-box',
        fontFamily: 'Montserrat',
        fontWeight: 500,
        borderStyle: 'solid',
        borderWidth: 1,
        borderRadius: 2,
        backgroundColor: '#FFF',
        textAlign: 'end',

        '&:focus': {
            backgroundColor: '#F6FCFF',
            border: '1px solid #1084D3',
            outline: 'none',
        },

        '&:disabled': {
            backgroundColor: 'rgba(227,233,237,0.25)',
            border: '1px solid #E3E9ED',
        },

        '&:read-only': {
            border: 'none'
        },

        '&:hover:read-write': {
            border: '1px solid #1084D3',
        }
    }
});

const SectionStyles = makeStyles({
    sectionTitle: {
        color: '#63a9dc',
        fontSize: '13px',
        display: 'flex',
        alignItems: 'center'
    }
})

const ErrorHighligterStyled = styled(ErrorHighligter)({
    minWidth: '350px !important',
})

const NumberFormatStyled = styled(NumberFormat)({
    width: '350px !important',
})

const InputWrraper = styled('div')({
    width: '100%',
    height: '34px',
    maxWidth: '350px',
    '& input': {
        height: '34px'
    }
})

const FunderWrraper = styled('div')({
    width: '100%',
    maxWidth: '350px',
})

const FlexStyled = styled(AssetColumn)({
    width: '100%',
    height: '34px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: '8px',
    marginLeft: 0,
    marginRight: 0,
})

const StyledFormLabel = styled(FormLabel)({
    color: '#767D84',
    display: 'flex',
    fontSize: '12px',
    fontFamily: 'Montserrat',
    fontWeight: 500,
    maxWidth: '300px'
})

const StyledInput = styled(Input)({
    marginTop: 4,
    marginBottom: 4,
    height: 32,
    width: '350px'
})

const DigiDateWrapper = styled('div')({
    '& .react-datepicker-wrapper': {
        width: '350px',
        height: '34px',
    },
    '& input': {
        maxWidth: '350px',
        height: '34px',
    }
})

const DigiDateInputStyled = styled(DigiDateInput)({
    width: '350px',
})
